import { render, staticRenderFns } from "./Kstudent.vue?vue&type=template&id=0d86ff3a"
import script from "./Kstudent.vue?vue&type=script&lang=js"
export * from "./Kstudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports